import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../../assets/css/customer/services/ServicesHero.css';

const ServicesHero = () => {
  return (
     <section className="contact-hero-section">
         <Container>
           <div className="contact-hero-content">
             {/* Main Heading */}
             <h1 className="contact-hero-heading">Packages</h1>
   
             {/* Description */}
             <p className="contact-hero-description">
               Choose from a variety of wedding packages designed to suit your budget and preferences, making your planning easy and convenient.
             </p>
           </div>
         </Container>
       </section>
  );
};

export default ServicesHero;